import moment from "moment";
import React from 'react';

const DateFormatted = ({ value, format='DD MMMM Y, hh:mm a' }) => {
    moment.locale('es');
    return <span data-testid={'date-formatted'}>{moment(value).format(format)}</span>
}

export default DateFormatted;